import EfLink from '@elem/ui/ef-link';
import EcoBlogCard from 'eco-design/sections/eco-blog-items/eco-blog-card';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { Fragment, useEffect, useState } from 'react';
import { queryCategoryItems } from '../../common/blog-api/queryCategoryItems';
import { LangText } from '../../common/blog-lang-text';
import BlogTimer from '../../common/blog-timer';
import { getBlogTagFromList } from '../../common/utils';
import EcoLink from 'eco-design/base/eco-link';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import gtm from '@/utils/gtm';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { categoryId, categoryName, items = [] } = data;
    const { locale = 'us' } = useRouter();
    const TextA = LangText[locale] || LangText['us'];
    const categoryHref = `/${locale}/blog/category/${categoryId}`;
    const [categoryNameA, setCategoryNameA] = useState(categoryName);
    const items2 = items.slice(0, 3);
    const [itemsA, setItemsA] = useState(items2);

    useEffect(() => {
        const getItemsForNone = async () => {
            const dataA = await queryCategoryItems(locale, {
                categoryId: categoryId,
            });
            setCategoryNameA(dataA?.categoryName);
            const itemsB2 = (dataA.items || []).slice(0, 3);
            setItemsA(itemsB2);
        };
        if (items2.length === 0 && categoryId) {
            getItemsForNone();
        }
    }, [categoryId, items2.length]);

    return (
        <GloLayout className="editor-blog-category-a" id={id}>
            <div className="editor-blog-category-a-h">
                <div className="editor-blog-category-a-h-l">{categoryNameA}</div>
                <div className="editor-blog-category-a-h-r">
                    <EfLink href={categoryHref} className="editor-blog-category-a-h-btn">
                        {TextA.ViewAll}
                    </EfLink>
                </div>
            </div>
            <div className="editor-blog-category-a-c">
                {itemsA?.map((item: any, index: number) => {
                    const thePage = JSON.parse(item.thePage || '{}');
                    const tagItem = getBlogTagFromList(item.blogTagList || [], categoryId);
                    return (
                        <Fragment key={index}>
                            <EcoBlogCard
                                label={tagItem.tag}
                                title={thePage.blogTitle}
                                pc={thePage.blogImgPc}
                                h5={thePage.blogImgH5}
                                href={item.seoUrl}
                                categoryHref={`/${locale}/blog/category/${categoryId}`}
                                timer={BlogTimer(item.newFirstReleaseTime || item.firstReleaseTime, locale)}
                            />
                        </Fragment>
                    );
                })}
            </div>
            <div className="editor-blog-category-a-right">
                {itemsA.map((item: any, index: number) => {
                    const thePage = JSON.parse(item.thePage || '{}');
                    const tagItem = getBlogTagFromList(item.blogTagList || [], categoryId);
                    const postHref = item.href || item.seoUrl;
                    const postCategoryHref = item.categoryHref || categoryHref;
                    const dataLayer = {
                        event: 'uaEvent',
                        event_name: 'select_news',
                        title_name: thePage?.blogTitle || '',
                        button_name: thePage?.blogTitle || '',
                        url: postHref,
                        __btn_id1: `editor-blog-category-a-right-item-${index + 1}`,
                        __btn_id2: postHref,
                        __btn_type: 'blog_category_card',
                    };
                    return (
                        <div key={index} className="editor-blog-category-a-right-item">
                            <EcoLink href={postHref} dataLayer={dataLayer} target="_blank" className="editor-blog-category-a-img">
                                <EcoImgVideo isVideo={item.isVideo} pc={thePage.blogImgPc} h5={thePage.blogImgH5} />
                            </EcoLink>
                            <div className="editor-blog-category-a-msg">
                                <EcoLink href={postCategoryHref} target="_blank" className="editor-blog-category-a-label">
                                    {tagItem.tag}
                                </EcoLink>
                                <EcoLink href={postHref} dataLayer={dataLayer} target="_blank" className="editor-blog-category-a-title">
                                    {thePage.blogTitle}
                                </EcoLink>
                            </div>
                        </div>
                    );
                })}
            </div>
        </GloLayout>
    );
}
